import { connect } from "react-redux";

import Component from "./Component";
import { getGameById } from "domain/Game/selectors";

const mapStateToProps = (state, { gameId }) => {
    return { game: getGameById(state, gameId) };
};

export default connect(mapStateToProps)(Component);
